import React, { useState } from "react";
import TrackSearch from "../components/user/TrackSearch";
import UserRequests from "../components/user/UserRequests";
import { getUserId } from "../utils/userId";
import DjPlaceSelection from "../components/user/DjPlaceSelection";
import NotificationBell from "../components/common/NotificationBell";
import useWebSocketNotification from "../hooks/useWebSocketNotification";

function UserPage() {
  const userId = getUserId();
  const [selectedDj, setSelectedDj] = useState(null);
  const [requestsRefresh, setRequestsRefresh] = useState(0);
  const notifications =
    JSON.parse(localStorage.getItem(`notifications_${userId}`)) || [];
  const refreshUserRequests = () => setRequestsRefresh((prev) => prev + 1);
  useWebSocketNotification(userId, false, refreshUserRequests);

  return (
    <div className="min-h-screen bg-gradient-to-b from-primary to-secondary text-textMain font-sans">
      <header className="container mx-auto flex justify-between items-center h-14 px-6 text-textMain user-header">
        <a
          href="/"
          className="text-2xl font-bold hover:text-accent transition duration-200"
        >
          SoundWish
        </a>
        <NotificationBell userId={userId} />
      </header>

      <main className="container mx-auto px-4 py-4">
        <DjPlaceSelection onDjChange={setSelectedDj} />
        <TrackSearch
          userId={userId}
          dj={selectedDj}
          refreshUserRequests={refreshUserRequests}
        />
        <UserRequests
          userId={userId}
          refreshTrigger={requestsRefresh}
          notifications={notifications}
        />
      </main>
    </div>
  );
}

export default UserPage;
